import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { HistoricCases } from "./HistoricCases";
import { TabMenu } from "../common/TabMenu";
import { IdentifyLead } from "./contract/IdentifyLead";
import { Exceptions } from "./contract/Exceptions";
import { CaseWrapper } from "./case/CaseWrapper";
import { Processes } from "./Processes";
import { useSelector } from "react-redux";
import { selectContract } from "../../redux/contract/selectors";
import { selectUserRoles } from "../../redux/authentication/selectors";
import { BACKOFFICE } from "../../Constantes/userRoles";
import { ROUTE_BILLING, ROUTE_CASES } from "../routes/routesConstants";
import { PauData } from "./contract/Pau";
import { Workshop } from "./contract/Workshop";
import { FactoryCases } from "./FactoryCases";
import { factoryActive } from "../../Constantes/factoryActive";
import { CaseStateSummary } from "./CaseStateSummary";
import { ContractSearch } from "./ContractSearch";
import { HistoricCaseDetail } from "./HistoricCaseDetail";
import { Divider, Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import homeIcon from "../../images/home.svg";
import { ChatRAG } from "./contract/ChatRAG";
import { AgentAssist } from "./chatRAG/Chat";
import { ORACLE_Customer } from "./contract/ORACLE_Customer";
import { ORACLE_Customer_Tickets } from "./contract/ORACLE_Customer_Tickets";
import { TicketInfo } from "./contract/TicketInfo";
import { ChildTicketsInfo } from "./contract/ChildTicketsInfo";

function PanelGrid(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const contract = useSelector(selectContract);
  const userRoles = useSelector(selectUserRoles);
  const currentCase = useSelector((state) => state.currentCase?.currentCase?.case);
  const childTickets = currentCase?.childTickets || contract?.case?.childTickets || [];

  const handleBackHome = () => {
    const isBackoffice = userRoles?.some(
      (r) => (typeof r === "string" ? r : r.name)?.toLowerCase() === BACKOFFICE.toLowerCase()
    );
    if (isBackoffice) {
      history.push(ROUTE_BILLING);
    } else {
      history.push(ROUTE_CASES);
    }
  };

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  useEffect(() => {
    handleScrollToTop();
  }, []);

  return (
    <div className="panel-main">
      <div className="panel-grid">
        <div className="panel-contract-cell">
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            style={{ textTransform: "none", fontWeight: "normal" }}
            startIcon={<img src={homeIcon} alt="" style={{ width: "1rem", height: "1rem" }} />}
            onClick={handleBackHome}
          >
            {t("BackToHome")}
          </Button>
          <ContractSearch />
          <div className="panel-lead-data-wrapper">
            <TabMenu
              variant={"fullWidth"}
              key="id-lead"
              labels={[
                { label: t("Customer") },
              ]}
            >
              <IdentifyLead mode={"customer"} />
              <div></div>
            </TabMenu>
          </div>
          <div className="panel-lead-data-wrapper">
            <TabMenu
              variant={"fullWidth"}
              key="id-ticket-info"
              labels={[{ label: t("TicketInfo.Title") }]}
            >
              <TicketInfo />
              <div></div>
            </TabMenu>
          </div>
          {childTickets && childTickets.length > 0 && (
            <div className="panel-lead-data-wrapper">
              <TabMenu
                variant={"fullWidth"}
                key="id-child-tickets"
                labels={[{ label: t("ChildTickets.Title") }]}
              >
                <ChildTicketsInfo childTickets={childTickets} />
                <div></div>
              </TabMenu>
            </div>
          )}
        </div>
        <div className="panel-case-cell">
          <CaseWrapper handleNewCase={props.handleNewCase} />
        </div>
      </div>
      <CaseStateSummary />
      <div className="panel-history-grid">
        <TabMenu
          key="id-historic"
          labels={[
            { label: t("CustomerHistory") }
            // { label: t("Process") },
            // { label: "Casos Fábrica", disabled: !factoryActive },
          ]}
          height={"100%"}
        >
          <HistoricCases />
          <div></div>

          {/* <Processes
            treeDisplay={"horizontal"}
            treeIframeId={"treeIframeHorizontal"}
          /> */}
          {/* <FactoryCases disabled/> */}
        </TabMenu>
        <div style={{ margin: "3rem 0" }}>
          <Divider orientation="horizontal" />
        </div>
        <HistoricCaseDetail />
      </div>
    </div>
  );
}

export { PanelGrid };
